import { rest } from 'msw'

export default [
  /**
   * 最新値一覧
   */
  rest.get('/swc-api/nodes/:nodeId/lastest-status', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
          "dataset_id": "dataset_1",
          "time": 1638284400000,
          "field_infos": [
            {
              "dataset_id": 'pw_uji_01',
              "field_name": 'P1KTA01',
              "operating_name": 'プロセス名1',
              "display_name": 'No.1活性炭塔殺菌用蒸気温度計',
              "field_type": 'analog',
              "unit": 'min',
              "recommended_value_min": 100,
              "recommended_value_max": 600,
              "customer_notification_rule": '>=200',
              "engineer_notification_rule": '>=200',
              "customer_notification_flag": true,
              "engineer_notification_flag": false,
              "large_process": '大工程1',
              "medium_process": '中工程1',
              "series": 'モジュール系列1',
            },
            {
              "dataset_id": 'pw_uji_02',
              "field_name": 'P1KTA02',
              "operating_name": 'プロセス名2',
              "display_name": 'No.2活性炭塔殺菌用蒸気温度計',
              "field_type": 'analog',
              "unit": 'min',
              "recommended_value_min": 100,
              "recommended_value_max": 300,
              "customer_notification_rule": '>=200',
              "engineer_notification_rule": '>=200',
              "customer_notification_flag": true,
              "engineer_notification_flag": false,
              "large_process": '大工程2',
              "medium_process": '中工程2',
              "series": 'モジュール系列2',
            },
          ],
          "field_values": [7657, 34]
        },
        {
          "dataset_id": "dataset_2",
          "time": null,
          "field_infos": [
            {
              "dataset_id": 'test_uji_01',
              "field_name": 'P1KTA03',
              "operating_name": 'プロセス名3',
              "display_name": 'No.3活性炭塔殺菌用蒸気温度計',
              "field_type": 'alert',
              "unit": 'min',
              "recommended_value_min": 456,
              "recommended_value_max": 7547,
              "customer_notification_rule": '>200',
              "engineer_notification_rule": '>=20',
              "customer_notification_flag": false,
              "engineer_notification_flag": true,
              "large_process": '大工程3',
              "medium_process": '中工程3',
              "series": 'モジュール系列3',
            },
            {
              "dataset_id": 'test_uji_02',
              "field_name": 'P1KTA04',
              "operating_name": 'プロセス名4',
              "display_name": 'No.4活性炭塔殺菌用蒸気温度計',
              "field_type": 'alert',
              "unit": 'min',
              "recommended_value_min": 45,
              "recommended_value_max": 545,
              "customer_notification_rule": '>=200',
              "engineer_notification_rule": '',
              "customer_notification_flag": false,
              "engineer_notification_flag": true,
              "large_process": '大工程4',
              "medium_process": '中工程4',
              "series": 'モジュール系列4',
            },
          ],
          "field_values": [0, 435]
        },
        {
          "dataset_id": "dataset_7",
          "time": null,
          "field_infos": [
            {
              "dataset_id": 'test2_uji_01',
              "field_name": 'P1KTA05',
              "operating_name": 'プロセス名5',
              "display_name": 'No.5活性炭塔殺菌用蒸気温度計',
              "field_type": 'process',
              "unit": 'min',
              "recommended_value_min": 100,
              "recommended_value_max": 600,
              "customer_notification_rule": '>=200',
              "engineer_notification_rule": '>=200',
              "customer_notification_flag": true,
              "engineer_notification_flag": true,
              "large_process": '大工程5',
              "medium_process": '中工程5',
              "series": 'モジュール系列5',
            },
            {
              "dataset_id": 'test2_uji_02',
              "field_name": 'P1KTA06',
              "operating_name": 'プロセス名6',
              "display_name": 'No.6活性炭塔殺菌用蒸気温度計',
              "field_type": 'process',
              "unit": 'min',
              "recommended_value_min": 100,
              "recommended_value_max": 6456,
              "customer_notification_rule": '<200',
              "engineer_notification_rule": '<150',
              "customer_notification_flag": true,
              "engineer_notification_flag": true,
              "large_process": '大工程1',
              "medium_process": '中工程1',
              "series": 'モジュール系列1',
            },
          ],
          "field_values": [3534, 34]
        },
        {
          "dataset_id": "dataset_8",
          "time": null,
          "field_infos": [
            {
              "dataset_id": 'pw_uji_01',
              "field_name": 'P1KTA07',
              "operating_name": 'プロセス名',
              "display_name": 'No.7活性炭塔殺菌用蒸気温度計',
              "field_type": 'settings',
              "unit": 'min',
              "recommended_value_min": 100,
              "recommended_value_max": 600,
              "customer_notification_rule": '>=200',
              "engineer_notification_rule": '>=200',
              "customer_notification_flag": true,
              "engineer_notification_flag": true,
              "large_process": '大工程1',
              "medium_process": '中工程1',
              "series": 'モジュール系列1',
            },
            {
              "dataset_id": 'pw_uji_01',
              "field_name": 'P1KTA08',
              "operating_name": 'プロセス名',
              "display_name": 'No.8活性炭塔殺菌用蒸気温度計',
              "field_type": 'settings',
              "unit": 'min',
              "recommended_value_min": 100,
              "recommended_value_max": 300,
              "customer_notification_rule": '>=200',
              "engineer_notification_rule": '>=200',
              "customer_notification_flag": true,
              "engineer_notification_flag": true,
              "large_process": '大工程1',
              "medium_process": '中工程1',
              "series": 'モジュール系列1',
            },
          ],
          "field_values": [123, 45]
        }
      ]),
    )
  }),
]
